import {
  WALLETCONNECT_LOG_LEVEL,
  WALLETCONNECT_PROJECT_ID,
  WALLETCONNECT_RELAY_URL,
} from "@/constants/envVariables";

export const STELLAR_NAMESPACE = "stellar";
export const STELLAR_MAINNET_CHAIN_ID = `${STELLAR_NAMESPACE}:pubnet`;
export const STELLAR_TESTNET_CHAIN_ID = `${STELLAR_NAMESPACE}:testnet`;

// Stellar JSON-RPC methods currently implemented by the VIA Wallet
export const STELLAR_METHOD_SIGN_TRANSACTION = "stellar_signTransaction";
export const STELLAR_METHOD_SEND_TRANSACTION = "stellar_sendTransaction";
export const STELLAR_METHOD_SIGN_MESSAGE = "stellar_signMessage";
// The method that can be used to get the Stellar public key from wallet
export const STELLAR_METHOD_GET_ADDRESS = "stellar_getAddress";
export const STELLAR_METHOD_GET_BALANCE = "stellar_getBalance";
export const STELLAR_METHOD_TRUST_ASSET = "stellar_trustAsset";

/**
 * XDR-based signing methods planned for the multisig integration
 * TODO: put them in `DEFAULT_CONNECT_PARAMS` until wallet implementation
 */
export const STELLAR_METHOD_SIGN_XDR = "stellar_signXDR";

export const STELLAR_SUPPORTED_METHODS = [
  STELLAR_METHOD_SIGN_TRANSACTION,
  STELLAR_METHOD_SEND_TRANSACTION,
  STELLAR_METHOD_SIGN_MESSAGE,
  STELLAR_METHOD_GET_ADDRESS,
  STELLAR_METHOD_GET_BALANCE,
  STELLAR_METHOD_TRUST_ASSET,
  STELLAR_METHOD_SIGN_XDR,
];

export const WC_METADATA_NAME = "Stellar Disbursement Platform";
export const WC_METADATA_DESCRIPTION =
  "SDP dashboard — multisig enrollment and disbursement signing via VIA Wallet.";

export const VIA_SESSION_OPTIONS_KEY = "via-session-options";

const currentUrl = typeof window !== "undefined" ? window.location.origin : "";

export const DEFAULT_INIT_PARAMS = {
  projectId: WALLETCONNECT_PROJECT_ID,
  relayUrl: WALLETCONNECT_RELAY_URL,
  logger: WALLETCONNECT_LOG_LEVEL,
  metadata: {
    name: WC_METADATA_NAME,
    description: WC_METADATA_DESCRIPTION,
    url: currentUrl,
    icons: currentUrl ? [`${currentUrl}/favicon.ico`] : [],
  },
};

export const DEFAULT_CONNECT_PARAMS = {
  requiredNamespaces: {
    [STELLAR_NAMESPACE]: {
      methods: STELLAR_SUPPORTED_METHODS,
      chains: [STELLAR_MAINNET_CHAIN_ID, STELLAR_TESTNET_CHAIN_ID],
      events: [],
    },
  },
};
